import React from 'react';
import PropTypes from 'prop-types';

import {configuredRadium} from '../utils/General';
import AddIcon from './tariff/icons/AddIcon';
import SubtractButton from './tariff/icons/SubtractButton';
import {t} from "./Translate";


const styles = {
    wrapper: {
        width: '100%',
        height: '60px',
    },
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#F2F5FC',
        borderRadius: '20px',
        alignItems: 'center'
    },
    enabledButton: {
        display: 'inline-block',
    },
    disabledButton: {
        visibility: 'hidden',
    },
    inputText: {
        color: '#09183A',
        fontSize: '14px',
        padding: '3px 0',
    },
    button: {
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        padding: 0,
        backgroundColor: '#F2F5FC',
    },
    infoText: {
        color: '#A4ADC1',
        fontSize: '14px',
        marginTop: '6px',
    },
};

const NumberInput = ({
                         user,
                         value,
                         text,
                         handleSubmit,
                         minValue,
                         additionalPrice,
                         additionalText,
                         disabledText,
                         country
                     }) => {
    function handleChange(NewValue) {
        if (NewValue >= minValue) {
            handleSubmit(NewValue);
        }
    }

    const currency = country && country === 'am' ? '֏' : '$';
    if (minValue > 0) {
        return (
            <div style={styles.wrapper}>
                <div style={{
                    padding: '0 10px',
                }}
                >
                    <div style={styles.container}>
                        <SubtractButton
                            additionalStyles={(value === minValue || additionalPrice === -1) ? styles.disabledButton : styles.enabledButton}
                            handleClick={() => {
                                handleChange(value - 1);
                            }}
                        />
                        <span style={styles.inputText}>
                              {`${value} ${text}`}
                        </span>
                        <AddIcon
                            additionalStyles={additionalPrice === -1 ? styles.disabledButton : styles.enabledButton}
                            handleClick={() => {
                                handleChange(value + 1);
                            }}
                        />
                    </div>
                </div>
                <p style={styles.infoText}>
                    {additionalPrice === -1 ? additionalText : `${additionalPrice} ${currency} ${t({
                        text: "forEachAdditional",
                        user
                    })} ${additionalText}`}
                </p>
            </div>
        );
    }
    return (
        <div style={styles.wrapper}>
      <span style={{
          fontSize: '20px',
          color: '#DDE4F6',
          paddingTop: '10px',
      }}
      >
        {disabledText}
      </span>
        </div>
    );
};


NumberInput.propTypes = {
    value: PropTypes.number,
    text: PropTypes.string,
    minValue: PropTypes.number,
    additionalPrice: PropTypes.number,
    additionalText: PropTypes.string,
    disabledText: PropTypes.string,
    country: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
};

NumberInput.defaultProps = {
    value: 0,
    text: '',
    minValue: 0,
    additionalPrice: 0,
    additionalText: 'item',
    disabledText: '',
};

export default configuredRadium(NumberInput);



// WEBPACK FOOTER //
// ./src/components/NumberInput.jsx